import {
  GoldenDomeNotificationType,
  GoldenDomeProductArea,
} from "@redotech/redo-model/golden-dome-notifications";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const updateGoldenDomeNotification = {
  name: "updateGoldenDomeNotification" as const,
  input: z.object({
    id: z.string(),
    appIds: z.array(z.string()).optional(),
    title: z.string().optional(),
    customMessage: z.string().optional(),
    notificationType: createEnum(GoldenDomeNotificationType).optional(),
    includeAppInstallationRemoved: z.boolean().optional(),
    notificationsSent: z
      .array(
        z.object({
          timestamp: z.date(),
          teamId: z.string(),
          appId: z.string(),
        }),
      )
      .optional(),
    productAreas: z.array(createEnum(GoldenDomeProductArea)).optional(),
  }),
  output: z.null(),
};
